export const PRE_AUTH_PARAMS_STORAGE_KEY = 'pre_auth_params';
// How long the pre auth params should be valid. After this duration, they should be discarded.
export const PRE_AUTH_EXPIRES_DURATION = 1000 * 60 * 15; // 15 minutes

import Cookies from 'universal-cookie';
import { getDomain } from './FeatureFlags';

// Borrowed directly from `fox-webapp` repository
// https://github.com/foxcorp-product/fox-webapp/blob/develop/apps/core/src/utils/clientRedirects.ts

const cookies = new Cookies();

const getCookieExpiration = ({ hours } = { hours: 24 }) => {
  return new Date(Date.now() + 1000 * 60 * 60 * hours);
};

export class PreAuthParams {
  constructor(stateUuid) {
    this.stateUuid = stateUuid;
  }

  get(key) {
    this.clearExpiredParams();

    if (!this.stateUuid) {
      return undefined;
    }

    const preAuthParams = cookies.get(PRE_AUTH_PARAMS_STORAGE_KEY) ?? {};

    if (!preAuthParams) {
      return undefined;
    }

    try {
      const stateParams = preAuthParams[this.stateUuid];

      if (stateParams[key]) {
        return stateParams[key];
      }
    } catch {
      return undefined;
    }

    return undefined;
  }

  set(key, value) {
    this.clearExpiredParams();

    if (!this.stateUuid) {
      return;
    }

    const preAuthParams = cookies.get(PRE_AUTH_PARAMS_STORAGE_KEY) ?? {};

    const newPreAuthParams = {
      ...preAuthParams,
      [this.stateUuid]: {
        ...(preAuthParams[this.stateUuid] ?? {}),
        [key]: value,
        expires: String(Date.now() + PRE_AUTH_EXPIRES_DURATION),
      },
    };

    cookies.set(PRE_AUTH_PARAMS_STORAGE_KEY, newPreAuthParams, {
      path: '/',
      domain: getDomain(),
      expires: getCookieExpiration(),
      sameSite: 'strict',
      secure: true,
    });
  }

  clearExpiredParams() {
    const preAuthParams = cookies.get(PRE_AUTH_PARAMS_STORAGE_KEY) ?? {};

    if (!preAuthParams) {
      return;
    }

    const filteredParams = Object.fromEntries(
      Object.entries(preAuthParams).filter(([, value]) => {
        if (Number(value.expires) < Date.now()) {
          return false;
        }

        return true;
      })
    );

    cookies.set(PRE_AUTH_PARAMS_STORAGE_KEY, filteredParams, {
      path: '/',
      domain: getDomain(),
      expires: getCookieExpiration(),
      sameSite: 'strict',
      secure: true,
    });
  }
}
